import React from "react";

function Razorpay() {
  return <div>hello</div>;
}

export default Razorpay;
